import { fetchError } from "redux/actions";
import handleError from "./handleApiError";
import JWTAuth from "services/auth/jwt";


export default async (action, cb, dispatch) => {
    try {
        let result = await action();
        await cb(result);
    } catch (error) {
        let err = handleError(error);
        dispatch(fetchError(err));
        dispatch(JWTAuth.logout(error));
    }
}